"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "help-container" };
const _hoisted_2 = { class: "help-tabs" };
const _hoisted_3 = { for: "radio-symbols" };
const _hoisted_4 = { for: "radio-standard-projects" };
const _hoisted_5 = { for: "radio-phases" };
const _hoisted_6 = { for: "radio-hotkeys" };
const _hoisted_7 = { for: "radio-rulebooks" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_HelpIconology = (0, vue_1.resolveComponent)("HelpIconology");
    const _component_HelpStandardProjects = (0, vue_1.resolveComponent)("HelpStandardProjects");
    const _component_HelpPhases = (0, vue_1.resolveComponent)("HelpPhases");
    const _component_HelpRulebooks = (0, vue_1.resolveComponent)("HelpRulebooks");
    const _component_HelpHotkeys = (0, vue_1.resolveComponent)("HelpHotkeys");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                type: "radio",
                name: "help-tab",
                id: "radio-symbols",
                value: "iconology",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.currentPage) = $event))
            }, null, 512), [
                [vue_1.vModelRadio, _ctx.currentPage]
            ]),
            (0, vue_1.createElementVNode)("label", _hoisted_3, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[5] || (_cache[5] = [
                        (0, vue_1.createTextVNode)("Game Iconology", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                type: "radio",
                name: "help-tab",
                id: "radio-standard-projects",
                value: "standard-projects",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.currentPage) = $event))
            }, null, 512), [
                [vue_1.vModelRadio, _ctx.currentPage]
            ]),
            (0, vue_1.createElementVNode)("label", _hoisted_4, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[6] || (_cache[6] = [
                        (0, vue_1.createTextVNode)("Standard Projects", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                type: "radio",
                name: "help-tab",
                id: "radio-phases",
                value: "phases",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.currentPage) = $event))
            }, null, 512), [
                [vue_1.vModelRadio, _ctx.currentPage]
            ]),
            (0, vue_1.createElementVNode)("label", _hoisted_5, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[7] || (_cache[7] = [
                        (0, vue_1.createTextVNode)("Game Phases", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                type: "radio",
                name: "help-tab",
                id: "radio-hotkeys",
                value: "hotkeys",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.currentPage) = $event))
            }, null, 512), [
                [vue_1.vModelRadio, _ctx.currentPage]
            ]),
            (0, vue_1.createElementVNode)("label", _hoisted_6, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[8] || (_cache[8] = [
                        (0, vue_1.createTextVNode)("Hot Keys", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ]),
            (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                type: "radio",
                name: "help-tab",
                id: "radio-rulebooks",
                value: "rulebooks",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.currentPage) = $event))
            }, null, 512), [
                [vue_1.vModelRadio, _ctx.currentPage]
            ]),
            (0, vue_1.createElementVNode)("label", _hoisted_7, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [...(_cache[9] || (_cache[9] = [
                        (0, vue_1.createTextVNode)("Rules", -1)
                    ]))])), [
                    [_directive_i18n]
                ])
            ])
        ]),
        (_ctx.isOpen('iconology'))
            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_HelpIconology, { key: 0 }))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.isOpen('standard-projects'))
            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_HelpStandardProjects, { key: 1 }))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.isOpen('phases'))
            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_HelpPhases, { key: 2 }))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.isOpen('rulebooks'))
            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_HelpRulebooks, { key: 3 }))
            : (0, vue_1.createCommentVNode)("", true),
        (_ctx.isOpen('hotkeys'))
            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_HelpHotkeys, { key: 4 }))
            : (0, vue_1.createCommentVNode)("", true)
    ]));
}
